declare namespace $ {

	export class $mol_icon_language_typescript extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=typescript.view.tree.d.ts.map